import { t } from 'i18next';

export enum RowStatus {
  Created = 'created',
  Completed = 'completed',
  Confirmed = 'confirmed',
  Approved = 'approved',
  Register = 'register',
  Pending = 'pending',
  PendingSignature = 'pending_signature',
  PendingPayment = 'pending_payment',
  Rejected = 'rejected',
  Canceled = 'canceled',
  Failed = 'failed',
  Expired = 'expired',
  Business = 'business',
  Directors = 'directors',
  Shareholders = 'shareholders'
}

export enum TypePayment {
  CreditCard = 'credit card',
  DebitCard = 'debit card'
}

export const getStatusText = (status: RowStatus): JSX.Element => {
  switch (status) {
    case RowStatus.Created:
      return <span className="inline-flex rounded-full bg-[#D4EDDA] px-3 py-1 text-xs font-semibold text-[#155724]">{t('others.othCreated')}</span>;
    case RowStatus.Completed:
      return <span className="inline-flex rounded-full bg-[#E8D4F1] px-3 py-1 text-xs font-semibold text-[#5415AB]">{t('others.othCompleted')}</span>;
    case RowStatus.Confirmed:
      return <span className="inline-flex rounded-full bg-[#D4EDDA] px-3 py-1 text-xs font-semibold text-[#155724]">{t('others.othCreated')}</span>;
    case RowStatus.Approved:
      return <span className="inline-flex rounded-full bg-[#D1F2E0] px-3 py-1 text-xs font-semibold text-[#06C051]">{t('others.othApproved')}</span>;
    case RowStatus.Register:
      return <span className="inline-flex rounded-full bg-[#D1F2E0] px-3 py-1 text-xs font-semibold text-[#06C051]">{t('others.othRegister')}</span>;
    case RowStatus.Pending:
      return <span className="inline-flex rounded-full bg-[#F3E8FF] px-3 py-1 text-xs font-semibold text-[#7C3AED]">{t('others.othPending')}</span>;
    case RowStatus.PendingSignature:
      return (
        <span className="inline-flex rounded-full bg-[#FEF3C7] px-3 py-1 text-xs font-semibold text-[#92400E]">{t('others.othPendingSignature')}</span>
      );
    case RowStatus.PendingPayment:
      return <span className="inline-flex rounded-full bg-[#EDE9FE] px-3 py-1 text-xs font-semibold text-[#6B21A8]">{t('others.othPendingPayment')}</span>;
    case RowStatus.Rejected:
      return <span className="inline-flex rounded-full bg-[#FEE2E2] px-3 py-1 text-xs font-semibold text-[#DC2626]">{t('others.othRejected')}</span>;
    case RowStatus.Canceled:
      return <span className="inline-flex rounded-full bg-[#FEE2E2] px-3 py-1 text-xs font-semibold text-[#DC2626]">{t('others.othCanceled')}</span>;
    case RowStatus.Failed:
      return <span className="inline-flex rounded-full bg-[#FEE2E2] px-3 py-1 text-xs font-semibold text-[#DC2626]">{t('others.othFailed')}</span>;
    case RowStatus.Expired:
      return <span className="inline-flex rounded-full bg-[#FEE2E2] px-3 py-1 text-xs font-semibold text-[#DC2626]">{t('others.othExpired')}</span>;

    case RowStatus.Business:
      return <span className="inline-flex rounded-full bg-[#F3F4F6] px-3 py-1 text-xs font-semibold text-[#6B7280]">{t('others.othBusiness')}</span>;

    case RowStatus.Directors:
      return <span className="inline-flex rounded-full bg-[#DBEAFE] px-3 py-1 text-xs font-semibold text-[#1E40AF]">{t('others.othDirectors')}</span>;

    case RowStatus.Shareholders:
      return <span className="inline-flex rounded-full bg-[#E0E7FF] px-3 py-1 text-xs font-semibold text-[#3730A3]">{t('others.othShareholders')}</span>;

    default:
      return <span className="inline-flex rounded-full bg-[#F3F4F6] px-3 py-1 text-xs font-semibold text-[#6B7280]">N/A</span>;
  }
};

export const getPaymentMethod = (paymentType: TypePayment) => {
  switch (paymentType) {
    case TypePayment.CreditCard:
      return (
        <span className="inline-flex rounded-full bg-[#DBEAFE] px-3 py-1 text-xs font-semibold text-[#1E40AF]">{t('others.othTypePaymentCredit')}</span>
      );
    default:
      return (
        <span className="inline-flex rounded-full bg-[#D1F2E0] px-3 py-1 text-xs font-semibold text-[#047857]">{t('others.othTypePaymentDebit')}</span>
      );
  }
};
